import React, { useContext, useEffect, useState } from 'react';
import { AngularServicesContext } from 'react-app';
import { useSelector } from 'react-redux';
import t from 'react-translate';
import OrgLevelProfileSettings from 'institutions/components/org-level-profile-settings';
import OrgLevelMetadataSettings from 'institutions/components/org-level-metadata-settings';
import AdvancedSettingsSwitch from 'institutions/components/advanced-settings-switch';
import { useAppDispatch } from 'redux/store';
import { getCurrentInstitution } from 'redux/selectors/institutions';
import { enableLearningCatalog } from 'redux/actions/org-level-metadata';

import SectionContent from '../section-content';
import { config } from '@config/pendo.config.json';

const DataConfiguration = () => {
  const { CurrentUserManager, $state } = useContext(AngularServicesContext);
  const { InstitutionsManager } = useContext(AngularServicesContext);
  const [showOrgLevelProfileModal, setShowOrglevelProfileModal] = useState(null);
  const [showOrgLevelMetadataSettingsModal, setShowOrgLevelMetadataSettingsModal] = useState(null);
  const [learningCatalogEnabled, setLearningCatalogEnabled] = useState(InstitutionsManager.institution.discoveryEnabled);

  const getProfileLink = () => $state.href('org-level-profile-modal', {
    userId: CurrentUserManager.user.id,
  });

  const dispatch = useAppDispatch();
  const currentInstitution = useSelector(getCurrentInstitution);
  const switchLearningCatalog = (value) => {
    dispatch(enableLearningCatalog({
      institutionId: currentInstitution.id,
      enabled: value,
    })).then((response) => {
      if (!response.error) {
        InstitutionsManager.institution.updateFromReact({
          discoveryEnabled: value,
        });
        setLearningCatalogEnabled(value);
      }
    });
  };

  return (
    <div>
      <div className='border-bottom border-gray-5 pb-6'>
        <SectionContent
          header={t.INSTITUTIONS.ADVANCED_SETTINGS.ORG_LEVEL_PROFILE.TITLE()}
          description={[t.INSTITUTIONS.ADVANCED_SETTINGS.ORG_LEVEL_PROFILE.DESCRIPTION(getProfileLink())]}
          showCTAButton
          ctaText={t.INSTITUTIONS.ADVANCED_SETTINGS.CONFIGURE()}
          onAction={showOrgLevelProfileModal}
          dataQa={config.pendo.settings.configureOrganizationProfileButton}
        />
      </div>
      <div className='border-bottom border-gray-5 py-6'>
        <SectionContent
          header={t.INSTITUTIONS.ADVANCED_SETTINGS.METADATA.TITLE()}
          description={[t.INSTITUTIONS.ADVANCED_SETTINGS.METADATA.DESCRIPTION()]}
          showCTAButton
          ctaText={t.INSTITUTIONS.ADVANCED_SETTINGS.CONFIGURE()}
          onAction={showOrgLevelMetadataSettingsModal}
          pendo-tag-name={config.pendo.settings.configureMetadataButton}
          dataQa={config.pendo.settings.configureMetadataButton}
        />
      </div>
      {/* Learning Catalog */}
      <div className='border-bottom border-gray-5 py-6'>
        <SectionContent
          header={t.INSTITUTIONS.ADVANCED_SETTINGS.METADATA.LEARNING_CATALOG.TITLE()}
          description={[t.INSTITUTIONS.ADVANCED_SETTINGS.METADATA.LEARNING_CATALOG.DESCRIPTION()]}
          extras={(
            <div className='d-flex align-self-start'>
              <AdvancedSettingsSwitch
                onChange={switchLearningCatalog}
                dataQa={config.pendo.settings.toggleLearningCatalog}
                value='vm.InstitutionsManager.institution.discoveryEnabled'
              />
              {
                learningCatalogEnabled && (
                  <span className='ml-2'>
                    <a onClick={showOrgLevelMetadataSettingsModal} className='text-primary'>
                      {t.INSTITUTIONS.ADVANCED_SETTINGS.METADATA.LEARNING_CATALOG.LINK_LABEL_TEXT()}
                    </a>
                    <span className='ml-1'>
                      {t.INSTITUTIONS.ADVANCED_SETTINGS.METADATA.LEARNING_CATALOG.LABEL_TEXT()}
                    </span>
                  </span>
                )
              }
            </div>
          )}
        />
      </div>
      <OrgLevelProfileSettings
        forwardShowModal={(func) => setShowOrglevelProfileModal(() => func)}
      />
      <OrgLevelMetadataSettings
        forwardShowModal={(func) => setShowOrgLevelMetadataSettingsModal(() => func)}
      />
    </div>
  );
};

export default DataConfiguration;
